import { useState } from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Editor = () => {

	const [text, setText] = useState(`
	<h1>
		<span style="font-size: 18px;">Quill Rich Text Editor</span>
	</h1>
	<p>
		<br>
	</p>
	<p>Quill is a free,
		<a href="https://github.com/quilljs/quill/" target="_blank">open source</a>WYSIWYG editor built for the modern web. With its
		<a href="http://quilljs.com/docs/modules/" target="_blank">extensible architecture</a>and a
		<a href="http://quilljs.com/docs/api/" target="_blank">expressive API</a>you can completely customize it to fulfill your needs. Some built in features include:</p>
	<p>
		<br>
	</p>
	<ul>
		<li>Fast and lightweight</li>
		<li>Semantic markup</li>
		<li>Standardized HTML between browsers</li>
		<li>Cross browser support including Chrome, Firefox, Safari, and IE 9+</li>
	</ul>
	<p>
		<br>
	</p>
	<p>
		<span style="font-size: 18px;">Downloads</span>
	</p>
	<p>
		<br>
	</p>
	<ul>
		<li>
			<a href="https://quilljs.com" target="_blank">Quill.js</a>, the free, open source WYSIWYG editor</li>
		<li>
			<a href="https://zenoamaro.github.io/react-quill" target="_blank">React-quill</a>, a React component that wraps Quill.jsdsd
		</li>
	</ul>
	<p>
		<br>
	</p>
	`)

	return (
		<ReactQuill
			value={text}
			theme={"snow"}
			modules={{
				toolbar: [
					[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
					[{ 'header': 1 }, { 'header': 2 }],
					[{ 'font': [] }],
					[{ 'size': ['small', false, 'large', 'huge'] }],
					['bold', 'italic', 'underline', 'strike'],
					[{ 'list': 'ordered' }, { 'list': 'bullet' }],
					[{ 'color': [] }, { 'background': [] }],
				],
				clipboard: {
					matchVisual: false,
				}
			}}
			formats={[
				"header",
				"font",
				"size",
				"bold",
				"italic",
				"underline",
				"strike",
				"blockquote",
				"list",
				"bullet",
				"indent",
				"link",
				"image",
				"color"
			]}
			onChange={v => setText(v)}
			className='flex-1 flex flex-col overflow-hidden'
		/>
	)
}

export default Editor